import { render, staticRenderFns } from "./BasesView.vue?vue&type=template&id=d6f0685e&scoped=true&"
import script from "./BasesView.vue?vue&type=script&lang=js&"
export * from "./BasesView.vue?vue&type=script&lang=js&"
import style0 from "./BasesView.vue?vue&type=style&index=0&id=d6f0685e&prod&lang=scss&scoped=true&"
import style1 from "./BasesView.vue?vue&type=style&index=1&id=d6f0685e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f0685e",
  null
  
)

export default component.exports